<div class="search-container">
  <div class="search">
    <form>
      <mat-form-field>
        <input
          #searchInput
          matInput
          autocomplete="off"
          spellcheck="false"
          minlength="3"
          [formControl]="searchControl"
          [placeholder]="TranslationKeys.FilterTypeSearch | translate"
          (blur)="searchInput.focus()"
        />
        @if (searchControl?.value?.length) {
          <i matSuffix (click)="onRemoveSearch()" [nimbusIcon]="ICONS.CLOSE_LIGHT"></i>
        }
      </mat-form-field>
    </form>
  </div>
</div>
